import type { Application } from '@domain/entities';
import type { IApplicationRepository } from '@domain/repositories';
import type { ApplicationPayload } from '@application/dto';

/**
 * Alta y edicion. En la edicion el `code` no viaja: es la clave con la que las
 * aplicaciones piden sus roles y no puede cambiar.
 */
export class SaveApplicationUseCase {
  constructor(private readonly applicationRepository: IApplicationRepository) {}

  async execute(payload: ApplicationPayload, id?: string): Promise<Application> {
    if (!id) {
      return this.applicationRepository.create(payload);
    }

    const { code: _code, ...changes } = payload;
    return this.applicationRepository.update(id, changes);
  }
}
